<!--
Chip Component — wraps PrimeVue Chip for compact pill-style elements.

Use for inline removable items (selected filter values, multi-select tokens,
small action chips). For static status indicators use <status-tag> instead.
-->

<template>
  <PrimeChip v-bind="$attrs">
    <slot />
  </PrimeChip>
</template>

<script setup lang="ts">
import PrimeChip from 'primevue/chip';

defineOptions({ name: 'Chip', inheritAttrs: false });
</script>
